/**
 * Shared email domain typo checker.
 *
 * Single source of truth for the near-miss domains flagged by Klaviyo
 * (see GC_Bad_Emails sheet, "Pattern and prevention" tab). Deliberately an
 * exact-match lookup, not fuzzy/edit-distance matching, so legitimate
 * country-code domains (gmail.de, yahoo.co.uk, hotmail.co.uk, ...) are never
 * touched without needing a separate allowlist.
 */
(() => {
  if (window.AweEmailTypoCheck) return;

  const DOMAIN_CORRECTIONS = {
    'gmail.co': 'gmail.com',
    'yahoo.co': 'yahoo.com',
    'aol.co': 'aol.com',
    'gmailc.om': 'gmail.com',
    'gmail.cc': 'gmail.com',
    'gmail.cam': 'gmail.com',
    'yanoo.com': 'yahoo.com',
    'erthlink.net': 'earthlink.net',
  };

  const BLOCKED_DOMAINS = new Set(['example.com', 'example.org', 'test.com']);

  function check(email) {
    const value = String(email || '').trim();
    const at = value.lastIndexOf('@');
    if (at === -1) return { type: 'ok' };

    const local = value.slice(0, at);
    const domain = value.slice(at + 1).toLowerCase();

    if (BLOCKED_DOMAINS.has(domain)) {
      return { type: 'block' };
    }

    const corrected = DOMAIN_CORRECTIONS[domain];
    if (corrected) {
      return { type: 'suggest', correctedEmail: `${local}@${corrected}` };
    }

    return { type: 'ok' };
  }

  /**
   * Builds a "Did you mean name@gmail.com?" inline suggestion with a
   * click-to-accept button, so the three forms that use this don't each
   * hand-roll the same markup.
   */
  function buildSuggestionMarkup(correctedEmail, onAccept) {
    const wrap = document.createElement('span');
    wrap.className = 'awe-typo-suggest';
    wrap.append('Did you mean ');

    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'awe-typo-suggest__accept';
    btn.style.cssText =
      'background:none;border:none;padding:0;margin:0;font:inherit;color:inherit;text-decoration:underline;cursor:pointer;';
    btn.textContent = correctedEmail;
    btn.addEventListener('click', onAccept);
    wrap.append(btn);
    wrap.append('?');

    return wrap;
  }

  window.AweEmailTypoCheck = { check, buildSuggestionMarkup };
})();
